module.exports = __webpack_public_path__ + "assets/35900bffb336e58f2ff8a7017fb826a0.mp3";